<template>
  <el-dialog :visible.sync="dialogVisiable" :close-on-click-modal="false" custom-class="position-center" top="0" width="580px">
    <div class="form-title">新增社区</div>

    <div class="form">
      <div class="form-body">
        <el-form :model="form" :rules="rules" ref="form" label-width="85px">
          <Region :region="regionData" @change="handleRegionChange" />

          <el-form-item label="社区名称：" prop="community_name">
            <el-input v-model="form.community_name" placeholder="请输入社区名称" maxlength="15" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="form-footer">
        <el-button
          type="primary"
          :disabled="!isFormSubmit"
          :loading="sending"
          @click="handleFormSubmit"
        >提 交</el-button>
        <div class="cancel-link" @click="dialogVisiable = false">取消</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { ApiZoneAdd, ApiZoneEdit } from '@/api/zone';

import { validateZoneName } from '@/validate';
import Region from './Region';


const defaultForm = {
  province: '',
  city: '',
  district: '',
  street: '',
  community_name: '',
};

// console.log(pcaCode);

export default {
  name: 'CDialogZoneAdd',
  components: {
    Region,
  },
  data() {
    return {
      dialogVisiable: false,
      sending: false,
      isFormSubmit: false,

      regionData: {
        province: '',
        city: '',
        district: '',
        street: '',
        },

      form: Object.assign({}, defaultForm),
      rules: {
        community_name: [
          {
            required: true,
            validator: validateZoneName,
            trigger: 'blur',
          },
        ],
      },
    };
  },
  watch: {
    form: {
      handler(value) {
        let tmpPass = true;

        Object.keys(value).forEach((key) => {
          if (value[key] === '') {
            tmpPass = false;
          }
        });

        this.isFormSubmit = tmpPass;
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
  },
  methods: {
    // 弹出框初始化
    handleOpen(param) {
      if (this.dialogVisiable) {
        return false;
      }

      this.dialogVisiable = true;

      this.$nextTick(() => {
        // console.log(param);
        if (param && param.community_id) {
          this.form = Object.assign({}, defaultForm, param);
        } else {
          this.form = Object.assign({}, defaultForm);
        }

        // console.log(this.form);

        this.regionData = {
            province: this.form.province || '',
            city: this.form.city || '',
            district: this.form.district || '',
            street: this.form.street || '',
        };

        this.$refs.form.resetFields();
      });
    },

    // 地址改变
    handleRegionChange(res) {
      console.log(res);
      this.form.province = res.province || '';
      this.form.city = res.city || '';
      this.form.district = res.district || '';
      this.form.street = res.street || '';
    },

    // 提交
    handleFormSubmit() {
      if (this.sending) {
        return false;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sending = true;

          this.form.create_user = this.$store.getters.userId;

          if (this.form.community_id) {
            const tmpForm = {
              community_id: this.form.community_id,
            };

            Object.keys(defaultForm).forEach((key) => {
              tmpForm[key] = this.form[key];
            });

            ApiZoneEdit(tmpForm)
              .then(() => {
                this.dialogVisiable = false;
                this.sending = false;

                this.$message({
                  type: 'success',
                  message: '修改成功！',
                });

                this.$parent.handleGetList();
              })
              .catch(() => {
                this.sending = false;
              });
          } else {
            ApiZoneAdd(this.form)
              .then(() => {
                this.dialogVisiable = false;
                this.sending = false;

                this.$message({
                  type: 'success',
                  message: '新增成功！',
                });

                this.$parent.handleGetList();
              })
              .catch(() => {
                this.sending = false;
              });
          }
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.form-title,
.form-footer {
    padding-left: 85px;
}
</style>
